// Verteilung der Server-Nachrichten an je einen Handler. Reine Logik ohne DOM und ohne Three.js,
// damit sie geprüft werden kann; die Handler selbst hängt main.ts ein.
//
// Der Vertrag kennt dreizehn Nachrichten (docs/architektur-paket-2.md, „Protokoll v2“; `farms` kam mit
// task-016 dazu). Seit task-016 verarbeitet main.ts sie alle. Der Verteiler kennt sie ohnehin: Der
// `never`-Zweig am Ende sorgt dafür, dass eine neue Nachrichtenart hier auffällt, sobald sie im
// Protokoll steht – nicht erst, wenn sie stumm im Nichts verschwindet.
import type {
  ActionResultMessage,
  ChestMessage,
  ClockMessage,
  FarmMessage,
  FarmsMessage,
  HelloMessage,
  InventoryMessage,
  KickedMessage,
  ParcelOwnerMessage,
  PlayerJoinedMessage,
  PlayerLeftMessage,
  PlayersMessage,
  SayMessage,
  ServerMessage,
} from '@bauernhof/shared';

/** Je Nachrichtenart ein Handler; alle sind wahlfrei, nicht Gehörtes verfällt still. */
export interface NachrichtenHandler {
  hello?(msg: HelloMessage): void;
  clock?(msg: ClockMessage): void;
  players?(msg: PlayersMessage): void;
  playerJoined?(msg: PlayerJoinedMessage): void;
  playerLeft?(msg: PlayerLeftMessage): void;
  farm?(msg: FarmMessage): void;
  /** Die Höfe eines Takts, gebündelt (task-016). */
  farms?(msg: FarmsMessage): void;
  inventory?(msg: InventoryMessage): void;
  chest?(msg: ChestMessage): void;
  actionResult?(msg: ActionResultMessage): void;
  say?(msg: SayMessage): void;
  kicked?(msg: KickedMessage): void;
  parcelOwner?(msg: ParcelOwnerMessage): void;
}

/** Gibt die Nachricht an den Handler ihrer Art weiter. */
export function verarbeiteNachricht(msg: ServerMessage, handler: NachrichtenHandler): void {
  switch (msg.t) {
    case 'hello':
      handler.hello?.(msg);
      return;
    case 'clock':
      handler.clock?.(msg);
      return;
    case 'players':
      handler.players?.(msg);
      return;
    case 'playerJoined':
      handler.playerJoined?.(msg);
      return;
    case 'playerLeft':
      handler.playerLeft?.(msg);
      return;
    case 'farm':
      handler.farm?.(msg);
      return;
    case 'farms':
      handler.farms?.(msg);
      return;
    case 'inventory':
      handler.inventory?.(msg);
      return;
    case 'chest':
      handler.chest?.(msg);
      return;
    case 'actionResult':
      handler.actionResult?.(msg);
      return;
    case 'say':
      handler.say?.(msg);
      return;
    case 'kicked':
      handler.kicked?.(msg);
      return;
    case 'parcelOwner':
      handler.parcelOwner?.(msg);
      return;
    default: {
      // Alle Arten sind abgedeckt; kommt eine dazu, meldet der Typecheck hier einen Fehler.
      const unbekannt: never = msg;
      void unbekannt;
      return;
    }
  }
}
